export enum Tags {
  SourcePublicMedia = 'sourcePublicMedia',
}
